import React, { useCallback, useState } from "react";
import { Redirect, useHistory, useLocation } from "react-router-dom";
import { useStores } from "../../hooks/useStores";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import ReactGA from "react-ga";
// import LogoImg from "../../assets/icons/timetrap-logo.svg";
import { LostPasswordTitle, Container } from "./styled";
import { Link, Text } from "@chakra-ui/layout";
import { ChangePasswordForm } from "../../components/ChangePasswordForm";
import { useEffect } from "react";
import { Box, Center, useToast } from "@chakra-ui/react";
import { isMobile } from "react-device-detect";

// const { Title } = Typography;

export const ChangePassword: React.FC = observer(() => {
  const { session } = useStores();
  const { t } = useTranslation();
  const location = useLocation();
  const history = useHistory();
  const toast = useToast();

  const [email, setEmail] = useState<string | null>("");
  const [token, setToken] = useState<string | null>("");

  // useEffect(() => {
  //   ReactGA.pageview("/change-password");
  // }, []);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);

    setEmail(searchParams.get("email"));
    setToken(searchParams.get("token"));
  }, [location]);

  const handleSubmit = useCallback(
    async (newPassword: string) => {
      try {
        if (!token) {
          throw new Error("Missing token");
        }

        if (!email) {
          throw new Error("Missing email");
        }

        await session.changePassword(email, newPassword, token);

        toast({
          title: t("common.actionExecutedSuccessfully"),
          status: "success",
        });

        const searchParams = new URLSearchParams(location.search);
        searchParams.delete("email");
        searchParams.delete("token");
        history.replace({
          pathname: location.pathname,
          search: searchParams.toString(),
        });
      } catch (err) {
        console.log(err);

        toast({
          title: t("common.error"),
          status: "error",
        });
      }
    },
    [token, session, email, toast, t, location, history]
  );

  if (session.isLogged) {
    return <Redirect to={"/"} />;
  }

  return (
    <Container>
      <Box
        boxShadow=" 0px 0px 20px rgba(51, 102, 255, 0.15)"
        p="32px"
        rounded="32px"
        bg="white"
        minH="400px"
        display="flex"
        flexDirection="column"
        justifyContent="space-between"
      >
        <div style={{ textAlign: "center", width: isMobile ? "" : "400px" }}>
          <LostPasswordTitle>
            {t("screens.changePassword.title")}
          </LostPasswordTitle>

          <ChangePasswordForm
            onSubmit={handleSubmit}
            isLoading={session.isSubmitting}
          />
        </div>
        <Text style={{ marginTop: "1rem", textAlign: "center" }}>
          <Link
            color="#000"
            href={"#/lost-password"}
            fontSize={10}
            fontWeight={500}
          >
            {t("screens.changePassword.back")}
          </Link>
        </Text>
      </Box>
    </Container>
  );
});
